import React from 'react';
import '../../../styles/GPT.css';
import '../../../styles/TicketStatusTiles.css';
import { MY_RAIL_GPT, POWERED_BY_GPT, YOU_CAN_ASK, GPT_URL } from './gptConstants';

const GPTComponent = () => {
  return (
    <a className="gptContainer" href={GPT_URL}>
      <div className="gptIcon"></div>
      <div className="gptContent">
        <div className="myRailgptContainer">
          <span className="myRailgpt">{MY_RAIL_GPT}</span> {POWERED_BY_GPT}
        </div>
        <div className="tellMeWhere">{YOU_CAN_ASK}</div>
      </div>
      <div className="gptArrow"></div>
    </a>
  );
};

export default GPTComponent;
